const ready = require('./utilities').ready;

const CONSENT_KEY = 'cookie_consent_preferences';

ready(init);

function init() {
  const wrapper = document.querySelector('.js-cookie-consent-wrapper');
  if (!wrapper) return;

  // Check if we are in EU (passed from server)
  // If data-is-eu is "true", user is in EU.
  const isEu = wrapper.dataset.isEu === 'true';
  const storedConsent = getStoredConsent();

  bindEvents();

  if (!isEu) {
    // Not EU: Automatically load all scripts and do not show banner
    activateScripts(['analytics', 'marketing']);
    return;
  }

  console.log('storedConsent', storedConsent);
  if (storedConsent) {
    // EU User has already consented/declined
    const categories = [];
    if (storedConsent.analytics) categories.push('analytics');
    if (storedConsent.marketing) categories.push('marketing');

    activateScripts(categories);
  } else {
    // EU User has not decided yet: Show banner
    showBanner();
  }
}

function getStoredConsent() {
  const stored = localStorage.getItem(CONSENT_KEY);
  if (stored) {
    try {
      return JSON.parse(stored);
    } catch (e) {
      return null;
    }
  }
  return null;
}

function setStoredConsent(preferences) {
  localStorage.setItem(CONSENT_KEY, JSON.stringify(preferences));
}

function bindEvents() {
  // Banner Buttons
  const acceptAllBtn = document.querySelector('.js-cookie-accept-all-btn');
  if (acceptAllBtn) {
    acceptAllBtn.addEventListener('click', function() {
      saveAndActivate({ analytics: true, marketing: true });
      hideBanner();
    });
  }

  const rejectBtn = document.querySelector('.js-cookie-reject-btn');
  if (rejectBtn) {
    rejectBtn.addEventListener('click', function() {
      saveAndActivate({ analytics: false, marketing: false });
      hideBanner();
    });
  }

  const settingsBtn = document.querySelector('.js-cookie-settings-btn');
  if (settingsBtn) {
    settingsBtn.addEventListener('click', openModal);
  }

  // Modal Buttons
  const closeButtons = document.querySelectorAll('.js-cookie-modal-close');
  closeButtons.forEach(btn => {
    btn.addEventListener('click', closeModal);
  });

  const saveBtn = document.querySelector('.js-cookie-save-preferences');
  if (saveBtn) {
    saveBtn.addEventListener('click', function() {
      const analytics = document.querySelector('.js-cookie-toggle[data-category="analytics"]').checked;
      const marketing = document.querySelector('.js-cookie-toggle[data-category="marketing"]').checked;
      saveAndActivate({ analytics: analytics, marketing: marketing });
      closeModal();
      hideBanner();
    });
  }

  // Footer Link
  const footerLink = document.querySelector('.js-open-cookie-settings');
  if (footerLink) {
    footerLink.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Load current settings into modal
      const stored = getStoredConsent() || { analytics: false, marketing: false };
      const analyticsToggle = document.querySelector('.js-cookie-toggle[data-category="analytics"]');
      const marketingToggle = document.querySelector('.js-cookie-toggle[data-category="marketing"]');
      
      if (analyticsToggle) analyticsToggle.checked = stored.analytics;
      if (marketingToggle) marketingToggle.checked = stored.marketing;
      
      openModal();
    });
  }
}

function showBanner() {
  const banner = document.querySelector('.js-cookie-consent-banner');
  if (banner) {
    banner.style.removeProperty('display');
  }
}

function hideBanner() {
  const banner = document.querySelector('.js-cookie-consent-banner');
  if (banner) {
    banner.style.display = 'none';
  }
}

function openModal() {
  const modal = document.querySelector('.js-cookie-consent-modal');
  if (modal) {
    modal.style.removeProperty('display');
    // Ensure flex for centering
    modal.style.display = 'flex';
  }
}

function closeModal() {
  const modal = document.querySelector('.js-cookie-consent-modal');
  if (modal) {
    modal.style.display = 'none';
  }
}

function saveAndActivate(preferences) {
  setStoredConsent(preferences);
  
  const categories = [];
  if (preferences.analytics) categories.push('analytics');
  if (preferences.marketing) categories.push('marketing');
  
  activateScripts(categories);
}

function activateScripts(allowedCategories) {
  const scripts = document.querySelectorAll('script[type="text/plain"][data-cookie-category]');
  
  scripts.forEach(script => {
    // Check if script is already loaded
    if (script.dataset.loaded === 'true') return;

    const categoryString = script.dataset.cookieCategory;
    if (!categoryString) return;

    const categories = categoryString.split(',').map(s => s.trim());
    
    // Check if any of the script's categories are allowed
    // Logic: If script is "marketing", we need "marketing" allowed.
    // If script is "analytics,marketing", we need EITHER? Or BOTH?
    // Usually, strict mode requires all. But for a library that serves both, we might enable if either is present.
    // I will assume "analytics,marketing" means it supports both, so if EITHER is enabled, we load it.
    const isAllowed = categories.some(cat => allowedCategories.includes(cat));

    if (isAllowed) {
      const newScript = document.createElement('script');
      newScript.type = 'text/javascript';
      
      if (script.dataset.src) {
        newScript.src = script.dataset.src;
      } else {
        newScript.textContent = script.textContent;
      }
      
      if (script.async) newScript.async = true;
      if (script.defer) newScript.defer = true;
      
      script.dataset.loaded = 'true';
      
      // Append to document body
      document.body.appendChild(newScript);
    }
  });
}
